"use client";

import { useState, useEffect } from "react";

interface OptInPopupProps {
  showToast: (msg: string) => void;
}

export default function OptInPopup({ showToast }: OptInPopupProps) {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailToggle, setEmailToggle] = useState(true);
  const [smsToggle, setSmsToggle] = useState(true);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("seb_popup_dismissed");
    if (dismissed) return;

    const timer = setTimeout(() => {
      setVisible(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    sessionStorage.setItem("seb_popup_dismissed", "true");
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleClose();
    showToast("Påmelding bekreftet! Du vil motta nyheter på SMS og e-post.");
  };

  if (!visible) return null;

  return (
    <div className="popup-card">
      {/* Close button */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "14px",
          right: "16px",
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.4)",
          fontSize: "1rem",
          cursor: "pointer",
          fontFamily: "Rajdhani, sans-serif",
          lineHeight: 1,
          padding: "4px",
        }}
        aria-label="Lukk"
      >
        ✕
      </button>

      {/* Title */}
      <p
        style={{
          fontFamily: "Rajdhani, sans-serif",
          fontWeight: 700,
          fontSize: "1.3rem",
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          color: "white",
          marginBottom: "8px",
          marginRight: "24px",
        }}
      >
        Få maskinnyheter først 🇳🇴
      </p>

      {/* Subtitle */}
      <p
        style={{
          fontFamily: "Nunito Sans, sans-serif",
          fontSize: "0.8rem",
          color: "rgba(255,255,255,0.5)",
          lineHeight: 1.6,
          marginBottom: "20px",
        }}
      >
        Meld deg på SMS og e-post for eksklusivt innhold, nye maskiner og programvareoppdateringer fra SebNorge.
      </p>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div>
          <label className="section-label" style={{ display: "block", marginBottom: "6px" }}>E-postadresse</label>
          <input
            type="email"
            className="input-line"
            placeholder="din@epost.no"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="section-label" style={{ display: "block", marginBottom: "6px" }}>Mobilnummer (SMS)</label>
          <input
            type="tel"
            className="input-line"
            placeholder="+47 000 00 000"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        {/* Toggles */}
        <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={emailToggle}
                onChange={(e) => setEmailToggle(e.target.checked)}
              />
              <span className="toggle-slider" />
            </label>
            <span style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "0.75rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.6)" }}>
              E-post varsler
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={smsToggle}
                onChange={(e) => setSmsToggle(e.target.checked)}
              />
              <span className="toggle-slider" />
            </label>
            <span style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "0.75rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.6)" }}>
              SMS varsler
            </span>
          </div>
        </div>

        <button type="submit" className="btn-full-white" style={{ marginTop: "4px" }}>
          Meld meg på →
        </button>

        <p style={{ fontFamily: "Nunito Sans, sans-serif", fontSize: "0.7rem", color: "rgba(255,255,255,0.3)", textAlign: "center" }}>
          Vi sender kun relevant innhold. Aldri spam. Avslutt når som helst.
        </p>
      </form>
    </div>
  );
}